/* ==========================================================================
   Toalla Exfoliante de Ducha XELAE
   Selecteur d'offres + TIROIR PANIER clone du tiroir Kaching de la source,
   branches sur le VRAI panier Shopify (/cart.js, /cart/add.js, /cart/change.js,
   puis /checkout).

   Aucun prix n'est ecrit en dur : tout vient de window.toallaExfolianteData,
   emis par la section produit a partir des donnees Shopify du produit.

   Format des prix : « 22,99€ », symbole APRES le montant et SANS espace,
   exactement comme la source (moneyFormat mesure :
   "{{amount_with_comma_separator}}€", source/kaching-config.json).
   Le meme format doit s'appliquer en Liquid et ici (§31.4).
   ========================================================================== */
(function () {
  'use strict';

  var DATA = window.toallaExfolianteData || {};
  var VARIANTS = DATA.variants || [];
  var OFFERS = DATA.offers || [];

  /* Libelles du tiroir, poses par la section panier. */
  var CART_I18N = (function () {
    var el = document.querySelector('[data-toa-cart-i18n]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  })();

  /* Racine de la locale. Deux sources, dans cet ordre :
     1. Shopify.routes.root, pose par le theme ("/es-es/" sous un marche) ;
     2. a defaut, le prefixe lu dans l'URL courante.
     Sans cela, un window.location = '/checkout' est absolu depuis la racine et
     PERD le prefixe de marche : le visiteur venu de /es-es/ retombe sur le
     checkout du marche racine (§30.14). */
  function racine() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    if (r) return r;
    var ici = (location.pathname.match(/^\/[a-z]{2}-[a-z]{2}(?=\/|$)/i) || [''])[0];
    return (ici || CART_I18N.prefixeMarche || '') + '/';
  }
  var ROOT = racine();
  function route(chemin) { return ROOT.replace(/\/$/, '') + '/' + chemin; }

  var state = {
    pack: DATA.defaultPack || null,
    color: DATA.defaultColor || null,
    units: {},
    busy: false,
    replie: {}
  };

  /* ---------- utilitaires ---------- */

  function formatMoney(cents) {
    var value = (Math.round(cents) / 100).toFixed(2).replace('.', ',');
    var parts = value.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',') + '€';
  }

  function echappe(t) {
    return String(t == null ? '' : t)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function each(selector, fn, root) {
    var nodes = (root || document).querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) fn(nodes[i], i);
  }

  function findVariant(pack, color) {
    for (var i = 0; i < VARIANTS.length; i++) {
      if (VARIANTS[i].pack === pack && VARIANTS[i].color === color) return VARIANTS[i];
    }
    return null;
  }

  function currentVariant() { return findVariant(state.pack, state.color); }

  /* Nombre d'unites d'un pack, declare par la section produit. Sert au prefixe
     « 3x » du titre dans le tiroir, comme sur la source. */
  function unitesDuPack(pack) {
    for (var i = 0; i < OFFERS.length; i++) {
      if (OFFERS[i].pack === pack) return OFFERS[i].units || 1;
    }
    return 1;
  }

  function badgeDuPack(pack) {
    for (var i = 0; i < OFFERS.length; i++) {
      if (OFFERS[i].pack === pack) return OFFERS[i].badge || '';
    }
    return '';
  }

  /* Prix barre du pack.
     La vitrine XELAE ne renvoie AUCUN compare_at_price (§30.10, revérifié le
     07-08-2026 : les 9 variantes sortent a 0 alors que l'admin porte 68,97 et
     114,95). Le prix barre et l'economie viennent donc du reglage de section,
     comme prevu par le repli. Le montant reellement facture reste celui de
     Shopify : seul l'affichage du barre est repris de la source. */
  function comparerDuPack(pack) {
    for (var i = 0; i < OFFERS.length; i++) {
      if (OFFERS[i].pack === pack) return parseInt(OFFERS[i].compare, 10) || 0;
    }
    return 0;
  }

  /* ---------- selecteur d'offres et de couleur ---------- */

  function unitCount(card) {
    return parseInt(card.getAttribute('data-toalla-exfoliante-units'), 10) || 1;
  }

  function initUnits() {
    each('[data-toalla-exfoliante-pack]', function (card) {
      var pack = card.getAttribute('data-toalla-exfoliante-pack');
      var n = unitCount(card);
      var list = [];
      for (var u = 0; u < n; u++) list.push(state.color);
      state.units[pack] = list;
    });
  }

  function paintSelection() {
    each('[data-toalla-exfoliante-pack]', function (card) {
      var pack = card.getAttribute('data-toalla-exfoliante-pack');
      var on = pack === state.pack;
      card.classList.toggle('is-selected', on);
      var radio = card.querySelector('input[type="radio"]');
      if (radio) radio.checked = on;

      var chosen = state.units[pack] || [];
      each('[data-toalla-exfoliante-unit]', function (row) {
        var u = parseInt(row.getAttribute('data-toalla-exfoliante-unit'), 10) - 1;
        each('[data-toalla-exfoliante-color]', function (sw) {
          var isOn = sw.getAttribute('data-toalla-exfoliante-color') === chosen[u];
          sw.classList.toggle('is-selected', isOn);
          sw.setAttribute('aria-pressed', isOn ? 'true' : 'false');
        }, row);
      }, card);
    });

    var v = currentVariant();
    each('[data-toalla-exfoliante-price]', function (el) {
      el.textContent = v ? formatMoney(v.price) : '';
    });
    each('[data-toalla-exfoliante-compare]', function (el) {
      var barre = (v && v.compare_at_price) || 0;
      if (!barre && v) barre = comparerDuPack(v.pack);
      if (v && barre > v.price) {
        el.textContent = formatMoney(barre);
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    });

    var btn = document.querySelector('[data-toalla-exfoliante-add]');
    if (btn) btn.disabled = !v || v.available === false;
  }

  /* Ecouteurs poses sur DOCUMENT, jamais sur les elements. Cause mesuree du
     « panier reste vide », 08-08-2026 : poses sur les noeuds trouves au
     demarrage, ils partent avec eux des que Shopify REMPLACE la section
     (editeur de theme, rechargement a chaud de l'apercu). Apres remplacement de
     section, mesure : coussin (qui delegue sur document) -> /cart/add.js part,
     panier = 3 ; toalla -> AUCUNE requete, panier = 0. */
  function bindSelectors() {
    initUnits();

    function choisirCouleur(sw, e) {
      var card = sw.closest('[data-toalla-exfoliante-pack]');
      var row = sw.closest('[data-toalla-exfoliante-unit]');
      if (!card || !row) return;
      e.preventDefault();
      e.stopPropagation();
      var pack = card.getAttribute('data-toalla-exfoliante-pack');
      var u = parseInt(row.getAttribute('data-toalla-exfoliante-unit'), 10) - 1;
      if (!state.units[pack]) state.units[pack] = [];
      state.units[pack][u] = sw.getAttribute('data-toalla-exfoliante-color');
      if (pack === state.pack && u === 0) state.color = state.units[pack][0];
      paintSelection();
    }

    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var sw = e.target.closest('[data-toalla-exfoliante-color]');
      if (sw) { choisirCouleur(sw, e); return; }
      var card = e.target.closest('[data-toalla-exfoliante-pack]');
      if (!card) return;
      state.pack = card.getAttribute('data-toalla-exfoliante-pack');
      state.color = (state.units[state.pack] || [])[0] || state.color;
      paintSelection();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      if (!e.target || !e.target.closest) return;
      var sw = e.target.closest('[data-toalla-exfoliante-color]');
      if (sw) choisirCouleur(sw, e);
    });
  }

  /* Couleurs des unites au-dela de la premiere, portees en proprietes de ligne
     pour que la preparation de commande sache quoi expedier, et pour que le
     tiroir affiche « #1 Negro / #2 Azul » comme la source. */
  function unitProperties() {
    var list = state.units[state.pack] || [];
    if (list.length < 2) return null;
    var label = DATA.colorLabel || 'Color';
    var props = {};
    for (var i = 0; i < list.length; i++) props[label + ' #' + (i + 1)] = list[i];
    return props;
  }

  /* ---------- panier reel ---------- */

  function getCart() {
    return fetch(route('cart.js'), { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function addToCart(variantId, quantity, properties) {
    var item = { id: variantId, quantity: quantity || 1 };
    if (properties) item.properties = properties;
    return fetch(route('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'add_error'); });
      return r.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch(route('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- rendu du tiroir, clone du markup Kaching ---------- */

  var ICONE_TAG =
    '<svg aria-hidden="true" focusable="false" viewBox="0 0 12 12"><path fill-rule="evenodd" clip-rule="evenodd" ' +
    'd="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" ' +
    'fill="currentColor"/></svg>';

  var ICONE_CHEVRON =
    '<svg viewBox="0 0 20 20" aria-hidden="true"><path fill-rule="evenodd" d="M14.53 12.28a.75.75 0 0 1-1.06 0l-3.47-3.47-3.47 3.47a.75.75 0 0 1-1.06-1.06l4-4a.75.75 0 0 1 1.06 0l4 4a.75.75 0 0 1 0 1.06Z"/></svg>';

  var ICONE_MOINS =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" fill="none" aria-hidden="true">' +
    '<path d="M2.08337 5H7.91671" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var ICONE_PLUS =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" fill="none" aria-hidden="true">' +
    '<path d="M5.00004 2.08334V7.91667M2.08337 5H7.91671" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var ICONE_POUBELLE =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
    '<path d="M10.6667 4V3.46667C10.6667 2.71993 10.6667 2.34656 10.5213 2.06135C10.3935 1.81047 10.1895 1.60649 9.93865 1.47866C9.65344 1.33334 9.28007 1.33334 8.53333 1.33334H7.46667C6.71993 1.33334 6.34656 1.33334 6.06135 1.47866C5.81046 1.60649 5.60649 1.81047 5.47866 2.06135C5.33333 2.34656 5.33333 2.71993 5.33333 3.46667V4M2 4H14M12.6667 4V11.4667C12.6667 12.5868 12.6667 13.1468 12.4487 13.5747C12.2569 13.951 11.951 14.2569 11.5746 14.4487C11.1468 14.6667 10.5868 14.6667 9.46667 14.6667H6.53333C5.41323 14.6667 4.85318 14.6667 4.42535 14.4487C4.04903 14.2569 3.74307 13.951 3.55132 13.5747C3.33333 13.1468 3.33333 12.5868 3.33333 11.4667V4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function vignette(url) {
    if (!url) return '';
    return url.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2');
  }

  /* Couleurs par unite : elles voyagent en proprietes de ligne « Color #1 ».
     La source affiche une ligne par unite, on fait pareil. */
  function couleursDeLigne(item) {
    var out = [];
    var props = item.properties || {};
    Object.keys(props).forEach(function (k) {
      var m = /#\s*(\d+)\s*$/.exec(k);
      if (m && props[k]) out.push({ n: parseInt(m[1], 10), valeur: props[k] });
    });
    out.sort(function (a, b) { return a.n - b.n; });
    if (out.length) return out;
    /* pack d'une seule unite : la couleur est celle de la variante */
    var opt = (item.options_with_values || []).filter(function (o) {
      return /color|couleur/i.test(o.name);
    })[0];
    return opt ? [{ n: 1, valeur: opt.value }] : [];
  }

  function ligneHTML(item, index) {
    var pack = (item.options_with_values || [])[0];
    var packNom = pack ? pack.value : '';
    var unites = unitesDuPack(packNom);
    var badge = badgeDuPack(packNom);
    var couleurs = couleursDeLigne(item);
    var replie = state.replie[item.key] === true;

    /* Prix barre de la ligne : Shopify n'applique aucune remise ici puisque la
       vitrine ne porte pas de compare_at_price. On reprend donc le barre de
       l'offre, comme la source l'affiche, et l'economie s'en deduit. */
    var ancien = item.original_line_price;
    var barrePack = comparerDuPack(packNom) * item.quantity;
    if (barrePack > item.final_line_price && ancien <= item.final_line_price) ancien = barrePack;
    var economie = ancien - item.final_line_price;
    var lib = CART_I18N;

    var prefixe = unites > 1
      ? '<span class="toa-cart-item__bundle-quantity">' + (unites * item.quantity) + 'x </span>'
      : '';

    var badgeHTML = badge
      ? '<div class="toa-cart__badge">' + ICONE_TAG + '<span>' + echappe(badge) + '</span></div>'
      : '';

    var toggleHTML = '';
    var listeHTML = '';
    if (couleurs.length) {
      if (couleurs.length > 1) {
        var motToggle = (replie ? (lib.afficher || 'Mostrar [N] artículos')
                                : (lib.masquer || 'Ocultar [N] artículos'))
          .replace('[N]', couleurs.length);
        toggleHTML =
          '<button type="button" class="toa-cart-item__toggle" data-toa-cart-toggle="' + echappe(item.key) + '"' +
          ' aria-expanded="' + (replie ? 'false' : 'true') + '">' +
          echappe(motToggle) + ICONE_CHEVRON + '</button>';
      }
      listeHTML =
        '<div class="toa-cart-item__variants"' + (replie ? ' hidden' : '') + '>' +
        '<span class="toa-cart-item__option-names">' + echappe(lib.couleur || 'Color:') + '</span>' +
        couleurs.map(function (c) {
          return '<div class="toa-cart-item__variants-row">' +
            '<span class="toa-cart-item__variant-index">#' + c.n + '</span>' +
            '<div class="toa-cart-item__variant-options">' + echappe(c.valeur) + '</div>' +
            '</div>';
        }).join('') +
        '</div>';
    }

    return '' +
      '<div class="toa-cart-item" data-toa-cart-line="' + echappe(item.key) + '">' +
        '<div class="toa-cart-item__image-container">' +
          (item.image
            ? '<img class="toa-cart-item__image" loading="lazy" src="' + echappe(vignette(item.image)) +
              '" alt="' + echappe(item.product_title) + '" width="80" height="80">'
            : '') +
        '</div>' +
        '<div class="toa-cart-item__content">' +
          '<div class="toa-cart-item__content-left">' +
            '<span class="toa-cart-item__title">' + prefixe + echappe(item.product_title) + '</span>' +
            badgeHTML +
            toggleHTML +
            listeHTML +
            '<div class="toa-cart-item__quantity-controls">' +
              '<button type="button" class="toa-cart-item__quantity-btn" data-toa-cart-qty="' + echappe(item.key) +
                '" data-toa-cart-qty-value="' + (item.quantity - 1) + '" aria-label="' + echappe(lib.moins || '-') + '">' +
                ICONE_MOINS + '</button>' +
              '<span class="toa-cart-item__quantity-value">' + (unites * item.quantity) + '</span>' +
              '<button type="button" class="toa-cart-item__quantity-btn" data-toa-cart-qty="' + echappe(item.key) +
                '" data-toa-cart-qty-value="' + (item.quantity + 1) + '" aria-label="' + echappe(lib.plus || '+') + '">' +
                ICONE_PLUS + '</button>' +
            '</div>' +
          '</div>' +
          '<div class="toa-cart-item__content-right">' +
            '<div class="toa-cart-item__price-info">' +
              (ancien > item.final_line_price
                ? '<s class="toa-cart-item__total-old">' + formatMoney(ancien) + '</s>'
                : '') +
              '<span class="toa-cart-item__total-final">' + formatMoney(item.final_line_price) + '</span>' +
              (economie > 0
                ? '<div class="toa-cart__badge">' + ICONE_TAG + '<span>' +
                  echappe(lib.economise || 'Ahorras') + ' ' + formatMoney(economie) + '</span></div>'
                : '') +
            '</div>' +
            '<button type="button" class="toa-cart-item__remove-btn" data-toa-cart-remove="' + echappe(item.key) +
              '" aria-label="' + echappe(lib.retirer || 'Quitar') + '">' + ICONE_POUBELLE + '</button>' +
          '</div>' +
        '</div>' +
      '</div>';
  }

  function majBarreLivraison(cart) {
    var seuil = parseInt(CART_I18N.envoiSeuil, 10) || 0;
    var fill = document.querySelector('[data-toa-cart-ship-fill]');
    var txt = document.querySelector('[data-toa-cart-ship-text]');
    if (!fill || !txt) return;
    if (seuil <= 0 || cart.total_price >= seuil) {
      fill.style.width = '100%';
      txt.textContent = CART_I18N.envoiAtteint || '';
      return;
    }
    var pct = Math.max(0, Math.min(100, (cart.total_price / seuil) * 100));
    fill.style.width = pct.toFixed(1) + '%';
    txt.textContent = (CART_I18N.envoiRestant || '')
      .replace('[X]', formatMoney(seuil - cart.total_price));
  }

  /* AUCUN texte de diagnostic dans le tiroir. Une note d'administration avait ete
     posee ici le 08-08-2026 : elle s'affichait en rouge dans le panier, sur la
     fiche. Le tiroir ne montre que ce qu'un client doit voir. */

  function renderCart(cart) {
    var items = document.querySelector('[data-toa-cart-items]');
    var contents = document.querySelector('[data-toa-cart-contents]');
    var footer = document.querySelector('[data-toa-cart-footer]');
    var vide = document.querySelector('[data-toa-cart-empty]');
    if (!items) return;

    /* La source compte les UNITES, pas les lignes : un pack 2+1 affiche « 3 »
       dans l'en-tete du tiroir comme dans le selecteur de quantite. Le clone
       affichait « 1 », c'est la difference la plus visible avec ecovia. */
    var unitesTotal = 0;
    for (var iu = 0; iu < (cart.items || []).length; iu++) {
      var itu = cart.items[iu];
      var pku = (itu.options_with_values || [])[0];
      unitesTotal += unitesDuPack(pku ? pku.value : '') * itu.quantity;
    }
    if (!unitesTotal) unitesTotal = cart.item_count;

    each('[data-toalla-exfoliante-cart-count]', function (el) {
      el.textContent = unitesTotal;
      el.style.display = unitesTotal > 0 ? '' : 'none';
    });
    each('[data-toa-cart-count]', function (el) { el.textContent = unitesTotal; });
    each('[data-toa-cart-count-sep]', function (el) { el.hidden = false; });

    var plein = cart.items.length > 0;
    if (contents) contents.hidden = !plein;
    if (footer) footer.hidden = !plein;
    if (vide) vide.hidden = plein;
    if (!plein) { items.innerHTML = ''; return; }

    items.innerHTML = cart.items.map(ligneHTML).join('');
    majBarreLivraison(cart);

    /* Economie totale : somme des economies de ligne, calculees ci-dessus a
       partir du prix barre de l'offre (la vitrine ne porte pas de
       compare_at_price, §30.10). */
    var economie = cart.items.reduce(function (acc, it) {
      var p = (it.options_with_values || [])[0];
      var barre = p ? comparerDuPack(p.value) * it.quantity : 0;
      var anc = it.original_line_price;
      if (barre > it.final_line_price && anc <= it.final_line_price) anc = barre;
      return acc + (anc - it.final_line_price);
    }, 0);
    var bloc = document.querySelector('[data-toa-cart-savings]');
    if (bloc) {
      bloc.hidden = economie <= 0;
      if (economie > 0) {
        var lbl = document.querySelector('[data-toa-cart-savings-label]');
        var amt = document.querySelector('[data-toa-cart-savings-amount]');
        var badges = cart.items.map(function (it) {
          var p = (it.options_with_values || [])[0];
          return p ? badgeDuPack(p.value) : '';
        }).filter(Boolean);
        var badgeBloc = document.querySelector('[data-toa-cart-savings-badge]');
        if (badgeBloc) badgeBloc.hidden = badges.length === 0;
        if (lbl) lbl.textContent = badges[0] || '';
        if (amt) amt.textContent = '-' + formatMoney(economie);
      }
    }
    each('[data-toa-cart-total]', function (el) { el.textContent = formatMoney(cart.total_price); });

    /* actions des lignes */
    each('[data-toa-cart-qty]', function (el) {
      el.addEventListener('click', function () {
        majLigne(el.getAttribute('data-toa-cart-qty'),
                 parseInt(el.getAttribute('data-toa-cart-qty-value'), 10));
      });
    }, items);
    each('[data-toa-cart-remove]', function (el) {
      el.addEventListener('click', function () {
        majLigne(el.getAttribute('data-toa-cart-remove'), 0);
      });
    }, items);
    each('[data-toa-cart-toggle]', function (el) {
      el.addEventListener('click', function () {
        var k = el.getAttribute('data-toa-cart-toggle');
        state.replie[k] = !state.replie[k];
        getCart().then(renderCart);
      });
    }, items);
  }

  function majLigne(key, quantite) {
    if (state.busy) return;
    state.busy = true;
    changeLine(key, Math.max(0, quantite))
      .then(renderCart)
      .catch(function () {})
      .then(function () { state.busy = false; });
  }

  /* ---------- compte a rebours du bandeau ---------- */

  function compteARebours() {
    var el = document.querySelector('[data-toa-cart-timer]');
    if (!el) return;
    var minutes = parseInt(CART_I18N.minutes, 10) || 10;
    var cle = 'toa-cart-expire';
    var fin = parseInt(sessionStorage.getItem(cle) || '0', 10);
    var maintenant = Date.now();
    if (!fin || fin < maintenant) {
      fin = maintenant + minutes * 60000;
      try { sessionStorage.setItem(cle, String(fin)); } catch (e) {}
    }
    function tick() {
      var reste = Math.max(0, fin - Date.now());
      var m = Math.floor(reste / 60000);
      var s = Math.floor((reste % 60000) / 1000);
      el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      if (reste > 0) setTimeout(tick, 1000);
    }
    tick();
  }

  /* ---------- ouverture / fermeture ---------- */

  function openCart() {
    var drawer = document.querySelector('[data-toa-cart]');
    if (drawer) { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); }
    document.body.style.overflow = 'hidden';
    getCart().then(renderCart).catch(function () {});
  }

  function closeCart() {
    var drawer = document.querySelector('[data-toa-cart]');
    if (drawer) { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); }
    document.body.style.overflow = '';
  }

  /* Le DOM fait foi juste avant l'ajout : apres un remplacement de section le
     markup revient a la selection par defaut de Liquid alors que `state` garde
     l'ancien choix, et on ajouterait un pack different de celui AFFICHE. */
  function resynchroniseDepuisDOM() {
    var card = document.querySelector('[data-toalla-exfoliante-pack].is-selected');
    if (!card) return;
    var pack = card.getAttribute('data-toalla-exfoliante-pack');
    if (!pack) return;
    var lignes = card.querySelectorAll('[data-toalla-exfoliante-unit]');
    var couleurs = [];
    for (var u = 0; u < lignes.length; u++) {
      var actif = lignes[u].querySelector('[data-toalla-exfoliante-color].is-selected');
      couleurs.push(actif ? actif.getAttribute('data-toalla-exfoliante-color') : state.color);
    }
    if (!couleurs.length) return;
    state.pack = pack;
    state.units[pack] = couleurs;
    state.color = couleurs[0];
  }

  function bindCart() {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeCart();
    });

    /* Delegation, meme raison qu'en bindSelectors : pose sur le bouton, l'ecouteur
       meurt avec lui au remplacement de section et le clic sur « Anadir al
       carrito » ne declenche PLUS RIEN, pas meme une requete. */
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;

      if (e.target.closest('[data-toalla-exfoliante-cart-open]')) {
        e.preventDefault(); openCart(); return;
      }
      if (e.target.closest('[data-toa-cart-close]')) {
        e.preventDefault(); closeCart(); return;
      }

      var caisse = e.target.closest('[data-toa-cart-checkout]');
      if (caisse) {
        e.preventDefault();
        var sp = caisse.querySelector('.toa-cart__checkout-button-spinner');
        if (sp) sp.hidden = false;
        window.location.href = route('checkout');
        return;
      }

      var add = e.target.closest('[data-toalla-exfoliante-add]');
      if (add) {
        e.preventDefault();
        resynchroniseDepuisDOM();
        var v = currentVariant();
        if (!v || state.busy) return;
        state.busy = true;
        add.classList.add('is-loading');
        addToCart(v.id, 1, unitProperties())
          .then(function () { openCart(); })
          .catch(function () {
            /* §31.13 : AUCUNE redirection vers /cart, c'est la page panier GLOBALE
               de la boutique et le client y quitte le tunnel. L'echec reste sur la
               fiche : on ouvre le tiroir (il lit /cart.js, donc l'etat reel) et on
               pose le message sous le bouton, style en ligne pour ne pas avoir a
               repousser la feuille de style. */
            var msg = document.querySelector('[data-toa-add-erreur]');
            if (!msg) {
              msg = document.createElement('p');
              msg.setAttribute('data-toa-add-erreur', '');
              msg.setAttribute('role', 'alert');
              msg.style.cssText = 'margin:10px 0 0;font-size:13px;font-weight:700;' +
                                  'line-height:1.4;color:#a70000;text-align:center;';
              add.parentNode.insertBefore(msg, add.nextSibling);
            }
            msg.textContent = CART_I18N.erreurAjout ||
              'No se ha podido anadir al carrito. Vuelve a intentarlo.';
            msg.hidden = false;
            openCart();
          })
          .then(function () {
            state.busy = false;
            add.classList.remove('is-loading');
          });
      }
    });
  }

  /* ---------- bandeaux defilants ---------- */

  function bindMarquees() {
    each('[data-toalla-exfoliante-marquee]', function (track) {
      if (track.getAttribute('data-cloned') === '1') return;
      track.innerHTML += track.innerHTML;
      track.setAttribute('data-cloned', '1');
    });
  }

  /* ---------- FAQ et accordeons ---------- */

  function bindAccordions() {
    each('[data-toalla-exfoliante-accordion]', function (head) {
      head.addEventListener('click', function () {
        var item = head.closest('[data-toalla-exfoliante-accordion-item]');
        if (!item) return;
        var open = item.classList.toggle('is-open');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------- jauges animees a l'entree dans le champ de vision (§31.7) ---------- */

  function bindJauges() {
    var cibles = document.querySelectorAll('[data-toalla-exfoliante-gauge]');
    if (!cibles.length) return;
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        var cible = parseFloat(el.getAttribute('data-toalla-exfoliante-gauge')) || 0;
        if (reduit) { el.style.width = cible + '%'; return; }
        var debut = null;
        var duree = 1100;
        function pas(t) {
          if (debut === null) debut = t;
          var p = Math.min(1, (t - debut) / duree);
          var e = 1 - Math.pow(1 - p, 3);       /* easeOutCubic */
          el.style.width = (cible * e).toFixed(2) + '%';
          if (p < 1) requestAnimationFrame(pas);
        }
        requestAnimationFrame(pas);
      });
    }, { threshold: 0.25 });
    for (var i = 0; i < cibles.length; i++) io.observe(cibles[i]);
  }

  function init() {
    bindSelectors();
    bindCart();
    bindMarquees();
    bindAccordions();
    bindJauges();
    compteARebours();
    paintSelection();
    getCart().then(renderCart).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
